import { createActionGroup, props } from '@ngrx/store';
import { PortalRole } from './portal-roles.model';

export const PortalRolesActions = createActionGroup({
  source: 'PortalRoles',
  events: {
    'Get Portal Roles': props<{ companyId: number }>(),
    'Get Portal Roles Success': props<{ portalRoles: PortalRole[] }>(),
    'Get Portal Roles Failure': props<{ error: any }>(),
  },
});